module.exports = __webpack_public_path__ + "img/sevilla.68587e8c.png";